var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{ref:"selectA",model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},_vm._l((_vm.option),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.name,"value":item.name}})}),1),_c('el-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }